export enum ThemeMode {
  Auto = 'auto',
  Light = 'light',
  Dark = 'dark',
}

const keys = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'] as const;

export type Breakpoint = typeof keys[number];
